import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface InlineErrorProps {
  message: string;
  className?: string;
  showIcon?: boolean;
  variant?: 'default' | 'destructive';
}

/**
 * InlineError - Contextual error messages near the action/field
 *
 * Used for:
 * - Form validation errors
 * - Field-specific errors
 * - Component-specific data loading errors
 * - User action errors (add/remove recall, create assignment, etc.)
 */
export const InlineError: React.FC<InlineErrorProps> = ({
  message,
  className,
  showIcon = true,
  variant = 'destructive'
}) => {
  if (!message) {
    return null;
  }

  return (
    <Alert variant={variant} className={cn('mt-2', className)} role='alert'>
      <div className='flex items-start gap-2'>
        {showIcon && <AlertCircle className='h-4 w-4 mt-0.5 flex-shrink-0' />}
        <AlertDescription className='text-sm'>{message}</AlertDescription>
      </div>
    </Alert>
  );
};
